import * as Msdyn365 from '@msdyn365-commerce/core';
import { ErrorCode } from '../../modules/order-details';
import { ensureAuthenticated } from '../../utilities/is-authenticated';
import { escapeODataStringLiteral } from '../../utilities/odata';

/**
 * GetEventConfig Input Action
 */
export class GetEventConfigInput implements Msdyn365.IActionInput {
    public timestamp: string;
    public userToken: string;

    constructor(ctx: Msdyn365.ICreateActionContext) {
        this.timestamp = new Date().getTime().toString();
        this.userToken = ctx.requestContext.user.token;
    }

    public getCacheKey = () => `GetEventConfig-${this.timestamp}-${this.userToken}`;
    public getCacheObjectType = () => 'GetEventConfig';
    public dataCacheType = (): Msdyn365.CacheType => 'none';
}

export interface IGetEventConfigData {
    '@data.context'?: string;
    value: IEventConfig[];
    error?: ErrorCode;
}

export interface IEventConfig {
    EventId: string;
    Active: boolean;
    Configurable: boolean;
    EventText: string;
}

const createInput = (args: Msdyn365.ICreateActionContext): Msdyn365.IActionInput => {
    return new GetEventConfigInput(args);
};

async function action(_: GetEventConfigInput, ctx: Msdyn365.IActionContext): Promise<IGetEventConfigData> {
    ensureAuthenticated(ctx);
    const response = await Msdyn365.sendRequest<IGetEventConfigData>(
        `${ctx.requestContext.apiSettings.baseUrl}Commerce/GetEventConfig(language='${escapeODataStringLiteral(
            ctx.requestContext.locale
        )}')`,
        'get',
        {},
        {
            headers: {
                OUN: ctx.requestContext.apiSettings.oun,
                Authorization: `id_token ${ctx.requestContext.user.token}`
            }
        }
    );
    if (response.status === 200 && response.data) {
        return { ...response.data };
    }
    return { ...({} as IGetEventConfigData), error: { errorCode: response.status, errorText: response.statusText } };
}

export default Msdyn365.createObservableDataAction({
    action: <Msdyn365.IAction<IGetEventConfigData>>action,
    id: 'GetEventConfig',
    input: createInput
});
